import { UserRolesGridView } from '~/components/system/user-roles';
import { PageContainer } from '~/components/page-container';

export function UserRoles() {
	return (
		<PageContainer>
			<UserRolesGridView />
		</PageContainer>
	);
}
